var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('header-name',[_vm._v("Asset Search")]),_vm._v(" "),_c('asset-search-form',{attrs:{"route-name":"asset-search.search"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }